import axios from "axios";
import store from './../redux/store';
import {logoutUser} from "../redux/reducer/authSlice";
import {apiUrl} from "../config/vars";

const Axios = axios.create({
    baseURL: apiUrl,
    withCredentials: true,
});

Axios.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem('access_token')}`;
    return config;
})

Axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    const mustLogoutStatusCode = [401, 419];

    if (mustLogoutStatusCode.includes(error.response.status)) {
        store.dispatch(logoutUser());
    }

    return Promise.reject(error);
});

export default Axios;